import { render, staticRenderFns } from "./inclusions.vue?vue&type=template&id=0353ddd6&"
import script from "./inclusions.vue?vue&type=script&lang=js&"
export * from "./inclusions.vue?vue&type=script&lang=js&"
import style0 from "./inclusions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports